import type { QuizOptions, QuizPurpose } from '@/types/configurationV2'

export type AnswerFilter = QuizOptions['extraction']['answerFilter']
type Extraction = QuizOptions['extraction']

/** 오답 풀기(wrong_in_review) 대상이 아닌 quiz_location — 블럭퀴즈는 오답 리뷰 대상에서 제외된다. */
export const WRONG_IN_REVIEW_EXCLUDED_LOCATIONS: QuizPurpose[] = ['block']

/** wrong_in_review 저작 시 후보가 비어 있을 때 채워 넣는 기본 후보. */
export const WRONG_IN_REVIEW_DEFAULT_LOCATIONS: QuizPurpose[] = ['selected', 'applied', 'review']

const WRONG_IN_REVIEW_SUGGESTED_LABEL = '오답 풀기'

/** wrong_in_review 선택 시 'block' 체크박스를 비활성화한다(자동 제외 대상). */
export function isBlockLocationDisabled(filter: AnswerFilter): boolean {
  return filter === 'wrong_in_review'
}

/** wrong_in_review 는 백엔드가 해설을 always 강제하므로 해설 노출 정책 편집을 잠근다. */
export function isAnswerExplanationLocked(filter: AnswerFilter): boolean {
  return filter === 'wrong_in_review'
}

/** 오답 부족 시 채움(shortageStrategy) 블록은 'incorrect' 에서만 노출. wrong_in_review 는 정확 집합이라 fill 없음. */
export function shouldShowShortageStrategy(filter: AnswerFilter): boolean {
  return filter === 'incorrect'
}

/**
 * answerFilter 변경 시 extraction 패치를 계산한다.
 * wrong_in_review 선택 시 block 을 quizLocations 에서 자동 제외하고, 비면 기본 후보로 채운다.
 * 원본 extraction 은 변형하지 않는다.
 */
export function applyAnswerFilterChange(extraction: Extraction, filter: AnswerFilter): Extraction {
  if (filter !== 'wrong_in_review') {
    return { ...extraction, answerFilter: filter }
  }

  const filtered = extraction.quizLocations.filter(
    (loc) => !WRONG_IN_REVIEW_EXCLUDED_LOCATIONS.includes(loc),
  )
  const quizLocations = filtered.length > 0 ? filtered : [...WRONG_IN_REVIEW_DEFAULT_LOCATIONS]
  return { ...extraction, answerFilter: filter, quizLocations }
}

/**
 * wrong_in_review 선택 + 현재 label 이 비어 있을 때 제안 label("오답 풀기")을 반환한다.
 * 제안할 것이 없으면 undefined (= 기존 label 유지).
 */
export function suggestLabelForFilter(
  filter: AnswerFilter,
  currentLabel: string | undefined,
): string | undefined {
  if (filter !== 'wrong_in_review') return undefined
  if (currentLabel && currentLabel.trim().length > 0) return undefined
  return WRONG_IN_REVIEW_SUGGESTED_LABEL
}
